import { sinatraOrigin } from '../../config'

import keycloakService from '../../keycloak_service'

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const listModels = (queryParams) => {
  const [, workspaceId] = queryParams;
  const body = workspaceId ? {
    workspace_id: workspaceId
  } : {};

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  }

  return postToApi('v1/api/models/list', fetchOptions)
}

export default listModels;
